import React, { useRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { Checkbox } from '@/components/common/CheckboxTag4/CheckboxTag4';
import styles from './checkbox.module.scss';

export interface IBaseRowCheckboxProps {
  onChange: (params: ICellRendererParams) => void;
  id?: string;
  checked?: boolean | null;
}

export interface BaseRowCheckboxProps extends ICellRendererParams, IBaseRowCheckboxProps { }

export default function BaseRowCheckbox(params: BaseRowCheckboxProps) {
  const { onChange, id, checked } = params;
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={styles['row-checkbox']}
      onClick={() => checkboxRef.current?.click()}
    >
      <Checkbox
        ref={checkboxRef}
        id={id}
        onChange={() => onChange?.(params)}
        checked={checked}
        containerProps={{ className: styles['checkbox-container'] }}
      />
    </div>
  );
}
